module.exports = __webpack_public_path__ + "img/light.586fe715.jpg";